import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronRight, Cpu, ShoppingBag, Building2, Truck, Briefcase, Landmark, Heart, Sparkles, HardHat, Shield, Radio } from 'lucide-react';
import { mockData } from '../mock';

const iconMap = {
  Cpu,
  ShoppingBag,
  Building2,
  HardHat,
  Sparkles,
  Truck,
  Briefcase,
  Landmark,
  Heart,
  Shield,
  Radio
};

const Industries = () => {
  const [activeCategory, setActiveCategory] = useState(null);

  return (
    <div className="min-h-screen bg-background text-foreground pt-36 pb-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-16"
        >
          <p className="corporate-eyebrow mb-4">Portfolio</p>
          <h1 className="text-4xl md:text-6xl font-semibold mb-6">Our Industries</h1>
          <p className="text-xl text-muted-foreground max-w-3xl">
            A diverse portfolio of companies driving innovation across multiple sectors worldwide
          </p>
        </motion.div>

        {/* Industries Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {mockData.industries.map((industry, index) => {
            const Icon = iconMap[industry.icon];
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                className={`bg-card border border-border p-8 cursor-pointer transition-all duration-400 hover:shadow-lg ${
                  activeCategory === industry.category
                    ? 'border-[#D4AF37] bg-[#D4AF37]/5'
                    : 'hover:border-[#D4AF37]/50'
                }`}
                onClick={() =>
                  setActiveCategory(
                    activeCategory === industry.category ? null : industry.category
                  )
                }
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 bg-[#D4AF37]/10 flex items-center justify-center">
                      <Icon size={28} className="text-[#D4AF37]" />
                    </div>
                    <h2 className="text-3xl font-bold tracking-tight">{industry.category}</h2>
                  </div>
                  <ChevronRight
                    size={24}
                    className={`text-[#D4AF37] transition-transform duration-300 ${
                      activeCategory === industry.category ? 'rotate-90' : ''
                    }`}
                  />
                </div>

                {/* Companies List */}
                <motion.div
                  initial={false}
                  animate={{
                    height: activeCategory === industry.category ? 'auto' : 0,
                    opacity: activeCategory === industry.category ? 1 : 0
                  }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <div className="space-y-6 mt-6 pt-6 border-t border-border">
                    {industry.companies.map((company, compIndex) => (
                      <div key={compIndex} className="group">
                        <h3 className="text-lg font-semibold mb-1 text-foreground group-hover:text-[#D4AF37] transition-colors">
                          {company.name}
                        </h3>
                        <p className="text-muted-foreground text-sm">{company.description}</p>
                      </div>
                    ))}
                  </div>
                </motion.div>

                {/* Company Count Badge */}
                {activeCategory !== industry.category && (
                  <div className="mt-4">
                    <span className="text-sm text-[#D4AF37] font-medium">
                      {industry.companies.length} {industry.companies.length === 1 ? 'Company' : 'Companies'}
                    </span>
                  </div>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Industries;